import React from "react";

import { PlainButton } from "@culturehq/components";

import celebrate from "images/social/linkedin/celebrate.svg";
import curious from "images/social/linkedin/curious.svg";
import insightful from "images/social/linkedin/insightful.svg";
import laugh from "images/social/linkedin/laugh.svg";
import like from "images/social/linkedin/like.svg";
import love from "images/social/linkedin/love.svg";
import support from "images/social/linkedin/support.svg";

const LinkedinReaction = ({
  children, onReacted, commentUrn, myReaction, linkedinShare, disabled
}) => {
  const handleReaction = params => {
    if (onReacted) {
      onReacted(params);
    }
  };

  return (
    <PlainButton className="Linkedin-Reactions__Btn">
      {children}
      {!disabled && (
        <div className="Linkedin-Reactions__Container">
          <span role="button" onClick={() => handleReaction({ reaction: "LIKE", commentUrn, deleting: myReaction?.reactionType === "LIKE", linkedinShare })} tabIndex={0}>
            <img className="Linkedin-Reaction" src={like} alt="Like" />
          </span>
          <span role="button" onClick={() => handleReaction({ reaction: "PRAISE", commentUrn, deleting: myReaction?.reactionType === "PRAISE", linkedinShare })} tabIndex={0}>
            <img className="Linkedin-Reaction" src={celebrate} alt="Celebrate" />
          </span>
          <span role="button" onClick={() => handleReaction({ reaction: "APPRECIATION", commentUrn, deleting: myReaction?.reactionType === "APPRECIATION", linkedinShare })} tabIndex={0}>
            <img className="Linkedin-Reaction" src={support} alt="Support" />
          </span>
          <span role="button" onClick={() => handleReaction({ reaction: "ENTERTAINMENT", commentUrn, deleting: myReaction?.reactionType === "ENTERTAINMENT", linkedinShare })} tabIndex={0}>
            <img className="Linkedin-Reaction" src={laugh} alt="Funny" />
          </span>
          <span role="button" onClick={() => handleReaction({ reaction: "EMPATHY", commentUrn, deleting: myReaction?.reactionType === "EMPATHY", linkedinShare })} tabIndex={0}>
            <img className="Linkedin-Reaction" src={love} alt="love" />
          </span>
          <span role="button" onClick={() => handleReaction({ reaction: "INTEREST", commentUrn, deleting: myReaction?.reactionType === "INTEREST", linkedinShare })} tabIndex={0}>
            <img className="Linkedin-Reaction" src={insightful} alt="Insightful" />
          </span>
          <span role="button" onClick={() => handleReaction({ reaction: "MAYBE", commentUrn, deleting: myReaction?.reactionType === "MAYBE", linkedinShare })} tabIndex={0}>
            <img className="Linkedin-Reaction" src={curious} alt="Curious" />
          </span>
        </div>
      )}
    </PlainButton>
  );
};

export default LinkedinReaction;
